export var defaultState = {
  marketingSubscriptionAccepted: false,
  licenceAccepted: false
};